var styles = {"mBreakpointMd":"(min-width: 960px)","wrapper":"styles_wrapper__3hA78 flex flex-auto","input":"styles_input__3BNLA hide","pill":"styles_pill__3dz_G","selected":"styles_selected__3i7OQ"};

export default styles;
//# sourceMappingURL=styles.css.js.map
